/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';

import { FormSection } from '@fitinsur/components'

function RenderSection({
  disableAll,
  formikProps,
  formikRef,
  isBound,
  idProduct,
  idOperation,
  idOperationParent,
  questionnaire,
}) {
  return (
    <FormSection
      sectionName="OBLIGOR_CONTRACT"
      formikRef={formikRef}
      disableAll={disableAll}
      values={formikProps.values}
      errors={formikProps.errors}
      setFieldValue={formikProps.setFieldValue}
      setFieldError={formikProps.setFieldError}
      questionnaire={questionnaire}
      idOperation={idOperation}
      idOperationParent={idOperationParent}
      idProduct={idProduct}
      isSelectMarketsScreen
    />
  )
}

const components = {
  RenderSection
}

export { components }